<template>
  <div class="mine">
    <MinePane :mine-data="mineData" />
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'

import MinePane from '@/components/mine/MinePane.vue'

export default {
  name: 'Mine',
  components: { MinePane },
  data () {
    return {
      mineData: 'data'
    }
  },
  created () {
    EventBus.$emit('onLoading', false)
  }
}
</script>
